module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('div', [_c('router-link', {
    staticClass: "btn-primary post",
    attrs: {
      "to": "/conversations/new"
    }
  }, [_vm._v("\n                Verfassen\n            ")])], 1), _vm._v(" "), _c('h1', [_vm._v("Nachrichten")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "conversations"
    }
  }, _vm._l((_vm.conversations), function(conversation) {
    return _c('router-link', {
      key: conversation.id,
      class: {
        item: true, unread: !conversation.read
      },
      attrs: {
        "to": ("/conversations/" + (conversation.partner.id))
      }
    }, [_c('dp', {
      attrs: {
        "who": conversation.partner
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm._f("name")(conversation.partner)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(conversation.message))])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-042faa02","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/conversations.vue
// module id = 218
// module chunks = 0